import styles from 'css/src/components/share-video/YouTubeChannelCallout.module.scss';

import React, { useCallback, useEffect, useRef, useState } from 'react';

import { ApiService } from 'js/src/client';
import Flags from 'js/src/libs/flags';
import { localStorageGet, LocalStorageKeys, localStorageSet } from 'js/src/libs/local-storage';
import { doesVideoHaveStoryblocksAudio } from 'js/src/luminary';
import { useLuminarySelector } from 'js/src/luminary/luminary-hooks';

const COPYRIGHT_CLAIMS_URL = '/dashboard/copyright-claims/';

type YouTubeChannelCalloutProps = {
    hasDownloaded: boolean;
};

const YouTubeChannelCallout: React.FC<YouTubeChannelCalloutProps> = ({ hasDownloaded }) => {
    const [visible, setVisible] = useState(false);
    const hasAutoShown = useRef(false);
    const [hasChannels, setHasChannels] = useState<boolean | null>(null);

    const isFeatureEnabled = Flags.canUseYoutubeChannelRegistration();
    const hasStoryblocksAudio = useLuminarySelector(doesVideoHaveStoryblocksAudio, []);

    useEffect(() => {
        if (!isFeatureEnabled) return;
        ApiService.youtubeChannelsList().then((response) => {
            setHasChannels(response.data.length > 0);
        });
    }, [isFeatureEnabled]);

    useEffect(() => {
        if (
            hasDownloaded &&
            hasChannels === false &&
            !hasAutoShown.current &&
            !localStorageGet(LocalStorageKeys.YOUTUBE_CHANNEL_CALLOUT_DISMISSED)
        ) {
            hasAutoShown.current = true;
            setVisible(true);
            analytics.track('Copyright Claims Callout Shown');
        }
    }, [hasDownloaded, hasChannels]);

    const handleDismiss = useCallback(() => {
        setVisible(false);
        localStorageSet(LocalStorageKeys.YOUTUBE_CHANNEL_CALLOUT_DISMISSED, true);
        analytics.track('Copyright Claims Callout Dismissed');
    }, []);

    if (!isFeatureEnabled || !hasStoryblocksAudio || !visible) {
        return null;
    }

    return (
        <div className={styles['callout']}>
            <button className={styles['dismiss']} onClick={handleDismiss}>
                &times;
            </button>
            <div className={styles['title']}>Uploading to YouTube?</div>
            <div className={styles['body']}>
                Music from our library can sometimes trigger copyright claims. Register your YouTube
                channel to automatically resolve them.{' '}
                <a href={COPYRIGHT_CLAIMS_URL}>Set up automatic resolution</a>
            </div>
        </div>
    );
};

export default YouTubeChannelCallout;
